import React from "react";
import * as ReactDOMServer from "react-dom/server";

import Tooltip from "../Tooltip";

export default function CellArrayItemWithTooltip({ arr }) {
  return (
    <>
      <span
        data-html={true}
        data-tip={ReactDOMServer.renderToString(
          arr.map((item) => <div>{item}</div>)
        )}
        className="text-in-one-string"
      >
        {arr.join(", ")}
      </span>
      <Tooltip />
    </>
  );
}
